export const CHAIN = "chain";
export const OFFICE = "office";
export const EMPLOYEE = "employee";
